import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';
import { UserService } from '../../../services/user/user.service';
import { User } from '../../models/user.model';

export const userResolver: ResolveFn<User | null> = () => {
  const userService = inject(UserService);

  return userService.getUserDetails({skipLogout: true}).pipe(
    catchError(() => {
      return of(null);
    })
  );
};
